import { useState, useEffect } from 'react';
import { useClientConfig } from '../utils/clientConfigContext';

export const useDarkMode = (): boolean => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);
  const { isDarkModeSupported = true } = useClientConfig();

  useEffect(() => {
    // If dark mode is not supported, always return false (light mode only)
    if (!isDarkModeSupported) {
      setIsDarkMode(false);
      return;
    }

    // Function to check if dark mode is enabled
    const checkDarkMode = (): boolean => {
      const body = document.body;
      return body.getAttribute('data-color-scheme') === 'dark';
    };

    // Set initial state
    setIsDarkMode(checkDarkMode());

    // Create a MutationObserver to watch for changes to the body element's attributes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-color-scheme') {
          setIsDarkMode(checkDarkMode());
        }
      });
    });

    // Start observing the body element for attribute changes
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-color-scheme'],
    });

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, [isDarkModeSupported]);

  return isDarkMode;
};
